import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewDiagnostico = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'diagnostico',
        name: 'Diagnostico',
        component: ViewDiagnostico,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
